<template>
  <div class="rooming">
    <p
      class="p"
      v-if="!reservation.editable"
    >
      Se <b>vencio el plazo</b> para poder editar los datos de esta reserva.
    </p>
    <div class="rooming-main">
      <div class="rooming-col-right">
        <div>
          <div
            v-for="passenger in passengers"
            :key="passenger.id"
          >
            <passenger
              :passenger="passenger"
              :reservation="reservation"
            />
          </div>
        </div>
      </div>
      <div class="rooming-col-left">
        <div class="locations mx--1 d-flex">
          <div
            class="px-1"
            v-for="layer in bus.map"
            :key="layer.title"
          >
            <template v-if="layer.layout.length">
              <div class="bus">
                <div class="bus-title">
                  <span slot="title">{{ layer.title }}</span>
                </div>
                <div class="bus-caption">
                  <span slot="category">{{ layer.categ_str }}</span>
                </div>
                <div
                  class="bus-seats"
                  :class="
                    'bus-seats_' +
                      layer.layout.reduce(
                        (a, b) =>
                          b instanceof Array && a < b.length ? b.length : a,
                        0
                      )
                  "
                >
                  <div class="bus-section">
                    <span>FRENTE</span>
                  </div>
                  <table>
                    <tr
                      v-for="(row, r) in layer.layout"
                      :key="r"
                    >
                      <td>{{ r + 1 }}</td>
                      <template v-for="(seat, c) in row">
                        <td
                          v-if="seat instanceof Object"
                          class="bus-seat"
                          @click="
                            seats.find(s => s.id == seat.id) &&
                              $emit('sit', seat)
                          "
                          :key="c"
                        >
                          <div v-if="seat.passenger">
                            <span class="bus-seat-tooltip">{{
                              seat.passenger.alt
                            }}</span>
                            <span class="bus-seat-dot" />
                          </div>
                          <seat-icon :fill="seat.fill" />
                        </td>
                        <td
                          v-else
                          :key="c"
                        >
                          <span class="bus-path" />
                        </td>
                      </template>
                      <td>{{ r + 1 }}</td>
                    </tr>
                  </table>
                </div>
              </div>
            </template>
          </div>
          <div class="px-1">
            <div class="hotels">
              <h4 class="hotels-title">
                HOTELES
              </h4>
              <div
                v-for="(hotel, h) in hotels"
                :key="h"
              >
                <div class="hotel">
                  <h4 class="hotel-name">
                    {{ hotel.name }}
                    <star
                      v-for="star in hotel.stars"
                      :key="star"
                    />
                  </h4>
                  <div class="hotel-rooms">
                    <div
                      v-for="(room, r) in hotel.rooms"
                      class="room"
                      :key="r"
                      @click="$emit('distribute', room)"
                    >
                      <h3 class="room-name">
                        {{ room.name }}
                      </h3>
                      <img
                        class="room-ico"
                        :src="'/api/images/beds/' + room.icon"
                      >
                      <span
                        class="room-tooltip"
                        v-if="room.passengers.length"
                      >
                        {{ room.passengers.map(p => p.alt).join(', ') }}
                      </span>
                      <div class="room-dots">
                        <span
                          v-for="dot in room.passengers"
                          class="room-dot"
                          :key="dot.id"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    class="hotel-notes_read px-1"
                    v-if="hotel.notes.length"
                  >
                    <p
                      v-for="(note, k) in hotel.notes"
                      :key="k"
                    >
                      {{ note }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="txt-right py-2 border-top my-3">
      <btn
        color="orange"
        size="xs"
        @click="modify(reservation.id, [])"
      >
        MODIFICAR
      </btn>
    </div>
  </div>
</template>
<script>
/* eslint no-mixed-spaces-and-tabs: 0 */
import Btn from '@/components/Btn'
import SeatIcon from '@/components/SeatIcon'
import Star from '@/components/Star'
import InputTags from '@/components/InputTags'
import PassengerIcon from '@/components/PassengerIcon'
import PassengerForm from './components/PassengerForm'
import Passenger from './components/Passenger'
import { SEAT_STATUS } from '@/constans'
import { clone } from '@/utils'

export default {
  components: {
    Btn,
    SeatIcon,
    Star,
    InputTags,
    PassengerIcon,
    PassengerForm,
    Passenger
  },

  name: 'Update',

  props: ['reservation'],

  data () {
    return {
      revocations: [],
      hover: null,
      annulment: null
    }
  },

  methods: {
    modify () {
      this.$router.push({ name: 'reservation_update', params: this.$route.params })
    }
  },

  computed: {
    passengers () {
      return this.reservation.passengers
        .filter(
          ({ id, revocation_id, status }) =>
            id &&
						status != 'revocate' &&
						!revocation_id &&
						!this.revocations.includes(id)
        )
        .sort((a, b) => ((x, y) => (x < y ? -1 : x > y ? 1 : 0))(a.type, b.type))
    },
    bus () {
      const bus = clone(this.reservation.departure.bus)
      const passengers = clone(this.reservation.passengers)
      bus.map = Object.values(bus.map).map(layer => {
        layer.layout = layer.layout.map(row =>
          row
            .map(col => this.reservation.departure.bus.seating[col] || col)
            .map(seat => {
              if (typeof seat === 'object') {
                if (passengers.some(p => p.seat_id == seat.id)) {
                  seat.fill = SEAT_STATUS.picked.hex
                  seat.passenger = passengers.find(p => p.seat_id == seat.id)
                } else {
                  seat.fill = SEAT_STATUS.reserved.hex
                }
              }
              return seat
            })
        )
        return layer
      })
      return bus
    },
    hotels () {
      return this.reservation.rooms.reduce((a, b, i, self) => {
        return a.find(h => h.id == b.hotel_id)
          ? a
          : a.concat([
            {
              id: b.hotel_id,
              stars: b.stars,
              name: b.hotel_name,
              notes: (el => (el ? el.notes : []))(
                (this.reservation.notes || []).find(
                  n => n.hotel_id == b.hotel_id
                )
              ),
              rooms: self
                .filter(r => r.hotel_id == b.hotel_id)
                .map(({ id, icon, name, uid }) => ({
                  id,
                  icon,
                  name,
                  passengers: this.reservation.passengers.filter(
                    ({ rooms }) => (rooms || []).some(r => r == uid)
                  )
                }))
            }
					  ])
      }, [])
    }
  }
}
</script>
